export const OBTAIN_TACHOGRAPH_CARD_ROUTE = 'tachograf/uzyskaj-karte-do-tachografu';
